import qs from 'qs';
import { post } from './axiosFun';
// 文件上传验证
const checkChunkUpload = data => {
  return post('/file/checkChunkUpload', qs.stringify(data), { timeout: 300000 });
};
// 切片文件上传
const chunkUpload = data => {
  return post('/file/chunkUpload', data);
};
// 文件上传并返回远程地址
const upload = data => {
  return post('/file/upload', data);
};
export default {
  checkChunkUpload,
  chunkUpload,
  upload
}




// WEBPACK FOOTER //
// ./src/api/common.js